/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReturnBox = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9.018 2.145a1 1 0 0 0-1.036 0l-5.5 3.333A1 1 0 0 0 2 6.333v5.334a1 1 0 0 0 .482.855l5.5 3.333a1 1 0 0 0 1.036 0l5.5-3.333a1 1 0 0 0 .482-.855V6.333a1 1 0 0 0-.482-.855zM7.5 10.23v2.995L4 11.103V8.11zm5.5.873-3.5 2.122V10.23L13 8.109zm-.93-4.77L8.5 8.497 4.93 6.333 8.5 4.17zM17 14h2c1.142 0 2 .88 2 1.883s-.858 1.884-2 1.884h-5.547l1.634-1.57-1.386-1.442-4.144 3.983 4.144 3.983 1.386-1.442-1.573-1.512H19c2.172 0 4-1.702 4-3.884S21.172 12 19 12h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgReturnBox as ReturnBox };
